import { Button } from 'components/common'
import Modal from 'components/modal'

type Props = {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
}

const ConfirmRoleChangeModal = ({ isOpen, onConfirm, onCancel }: Props) => {
  return (
    <Modal
      width={550}
      title="Change role to Super Admin?"
      titleClassname="text-xl font-semibold max-w-xl"
      isOpen={isOpen}
      closeModal={onCancel}
      customStyle={{
        padding: '25px 40px',
      }}
    >
      <>
        <div className="text-sm text-gray-700">
          Switching this user to <strong>Super Admin</strong> will discard their
          current page access and grant <strong>Editor</strong> access to every
          page. This change applies to the form immediately — to restore the
          original access, reload the page without saving.
        </div>

        {/* Actions */}
        <div className="mt-6 flex w-full items-center gap-5">
          <Button
            onClick={onConfirm}
            className="w-full"
            buttonText="Confirm"
            type="button"
          />
          <Button
            className="w-full"
            buttonText="Cancel"
            variant="outline"
            type="button"
            onClick={onCancel}
          />
        </div>
      </>
    </Modal>
  )
}

export default ConfirmRoleChangeModal
